/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('Messages.title') }}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container mc-white-container-no-padding" style="padding-top: 0px">

        <ion-segment mode="md" color="secondary" @ionChange="segmentChanged($event)" :value="selectedSegment">
          <ion-segment-button mode="md" value="carpool">
            <ion-badge v-if="user.unreadCarpoolMessageNumber && user.unreadCarpoolMessageNumber > 0" class="mc-message-badge-title" color="danger">{{ user.unreadCarpoolMessageNumber }}</ion-badge>
            <span class="mdi mdi-24px mdi-car ion-margin-top"></span>
            <ion-label class="mt-0">{{ $t('Messages.carpool') }}</ion-label>
           </ion-segment-button>
          <ion-segment-button mode="md" value="direct">
            <ion-badge v-if="user.unreadDirectMessageNumber && user.unreadDirectMessageNumber > 0" class="mc-message-badge-title" color="danger">{{ user.unreadDirectMessageNumber }}</ion-badge>
            <span class="mdi mdi-24px mdi-chat ion-margin-top"></span>
            <ion-label class="mt-0">{{ $t('Messages.direct') }}</ion-label>
           </ion-segment-button>
          <ion-segment-button mode="md" value="solidary" v-if="this.hasTransportSolidary || this.hasTransportSolidaryModule">
            <ion-badge v-if="user.unreadSolidaryMessageNumber && user.unreadSolidaryMessageNumber > 0" class="mc-message-badge-title" color="danger">{{ user.unreadSolidaryMessageNumber }}</ion-badge>
            <span class="mdi mdi-24px mdi-hand-heart ion-margin-top"></span>
            <ion-label class="mt-0">{{ $t('Messages.solidary') }}</ion-label>
          </ion-segment-button>
        </ion-segment>


        <div class="ion-text-center ion-margin-top" v-if="isStatus('loading')">
          <ion-icon size="large" color="primary" class="rotating" name="sync"></ion-icon>
        </div>

        <div class="ion-text-center ion-margin-top" v-if="isStatus('error')">
          {{ $t('Messages.error')}}
        </div>

        <div class="ion-text-center ion-margin-top" v-if="isStatus('success') && messages.length == 0">
          {{ $t('Messages.none')}}
        </div>

        <ion-list v-if="isStatus('success')">
          <ion-item-sliding v-for="message in messages" :key="message.id">
            <ion-item class="message-list" @click="goToMessage(message)">
              <ion-avatar class="ion-margin-end ion-margin-start avatar position-relative">
                <img v-if="message.avatarsRecipient" v-bind:src="message.avatarsRecipient" alt="" />
                <img v-if="!message.avatarsRecipient" src="/assets/user.png" alt="" />
                <ion-icon v-if="showExperienced && message.experienced" class="experienced" name="star"></ion-icon>
              </ion-avatar>
              <ion-label>
                <p class="message-name d-flex align-center">
                  <img class="c-icon mr-5" v-if="message.blockerId" style="visibility: visible" src="/assets/account-cancel.png"/><b>{{message.givenName}} {{message.shortFamilyName}}</b>
                  <ion-badge v-if="message.unreadMessages && message.unreadMessages > 0" class="mc-message-badge" color="danger">{{ message.unreadMessages }}</ion-badge>
                </p>
                <p
                  v-if="message.carpoolInfos"
                >{{message.carpoolInfos.origin}} → {{message.carpoolInfos.destination}}</p>
                <p v-if="message.carpoolInfos"> {{moment(message.carpoolInfos.criteria.fromDate , 'ddd D MMMM')}} <span v-if="message.carpoolInfos.criteria.fromTime">{{moment(message.carpoolInfos.criteria.fromTime, ' à HH[h]mm' , 'utc')}}</span></p>
                <p v-if="!message.carpoolInfos">{{moment(message.date, 'ddd D MMMM à HH[h]mm')}}</p>
              </ion-label>
            </ion-item>
            <!--
            <ion-item-options side="end">
              <ion-item-option color="danger" @click="deleteThreadAlertConfirm(message.idMessage)">{{$t('Commons.delete')}}</ion-item-option>
            </ion-item-options>
            -->
          </ion-item-sliding>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">

  .mt-0 {
    margin-top: 0px;
  }

  .mr-5 {
    margin-right : 5px;
  }

.mc-messages-type-selector {
  @media screen and (max-width: 320px) {
    flex-wrap: wrap;
    justify-content: center;
  }
}
.top-buttons-padding {
  padding-right: 30px;
  padding-left: 30px;
}
.message-list {
  color: var(--ion-color-primary);
}
.message-name {
  font-size: 16px !important;
}

.avatar {
  width: 60px;
  height: 60px;
  background-color: #c4c4c4;
}

hr {
  background-color: rgba(0, 0, 0, 0.1);
}

  .mc-message-badge {
    padding-right: 5px;
    padding-left: 5px;
    margin-left: 10px;
    border-radius: 10px;
    min-width: 20px;
  }

  .mc-message-badge-title {
    position: absolute;
    padding-right: 5px;
    padding-left: 5px;
    margin-left: 55px;
    margin-top: -21px;
    border-radius: 10px;
    min-width: 20px;
  }
</style>

<script>
import {toast} from "../../Shared/Mixin/toast.mixin";
import {alertController} from "@ionic/vue";

export default {
  name: "messages",
  data() {
    return {
      instanceName : process.env.VUE_APP_INSTANCE,
      selectedSegment: 'carpool',
      showExperienced: JSON.parse(process.env.VUE_APP_EXPERIENCED),
      hasTransportSolidary : JSON.parse(process.env.VUE_APP_SHOW_SOLIDARITY_TRANSPORT),
      hasTransportSolidaryModule : JSON.parse(process.env.VUE_APP_MODULE).SOLIDARYTRANSPORT
    };
  },
  mixins: [toast],
  computed: {
    user: {
      get() {
        return this.$store.state.userStore.user;
      }
    },
    messages: {
      get() {
        switch (this.selectedSegment) {
          case 'carpool':
            return this.$store.state.messageStore.messagesCarpool;
          case 'direct':
            return this.$store.state.messageStore.messagesDirect;
          case 'solidary':
            return this.$store.state.messageStore.messagesSolidary;
        }
      }
    }
  },
  created() {
    this.$store.dispatch(
      "getAllMessagesCarpool",
      this.$store.state.userStore.user.id
    );
    this.$store.dispatch(
      "getAllMessagesDirect",
      this.$store.state.userStore.user.id
    );
    if (this.hasTransportSolidary || this.hasTransportSolidaryModule) {
      this.$store.dispatch(
        "getAllMessagesSolidary",
        this.$store.state.userStore.user.id
      );
    }
  },
  methods: {
    goToMessage(message) {
      message.unreadMessages = 0;
      this.$router.push({
        name: "message",
        params: {
          idAsk: message.idAsk ? message.idAsk : -99,
          idRecipient: message.idRecipient
        }
      });
    },
    deleteThreadAlertConfirm(messageId) {
      return alertController
        .create({
          header: this.$t("Messages.confirmDeleteHeader"),
          message: this.$t("Messages.confirmDeleteText"),
          buttons: [
            {
              text: this.$t("Commons.cancel"),
              role: "cancel",
              cssClass: "secondary"
            },
            {
              text: this.$t("Commons.confirm"),
              handler: () => {
                this.deleteThread(messageId);
              }
            }
          ]
        })
        .then(a => a.present());
    },
    deleteThread(messageId) {
      this.$store
        .dispatch("deleteThread", messageId)
        .then(res => {
          this.presentToast(this.$t("Message.delete-success"), "success");
        })
        .catch(err => {
          this.presentToast(this.$t("Commons.error"), "tertiary");
        });
    },
    segmentChanged(event) {
      this.selectedSegment = event.detail.value;
    },
    isStatus(status) {
      switch (this.selectedSegment) {
        case 'carpool':
          return this.$store.state.messageStore.statusMessagesCarpool == status;
        case 'direct':
          return this.$store.state.messageStore.statusMessagesDirect == status;
        case 'solidary':
          return this.$store.state.messageStore.statusMessagesSolidary == status;
      }
    }
  }
};
</script>
